/* @flow */
import moment from 'moment'

export const isValidDate=(dateString:string)=> {
    // First check for the pattern
    if(!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateString))
        return false;

    // Parse the date parts to integers
    const parts = dateString.split("/");
    const day = parseInt(parts[1], 10);
    const month = parseInt(parts[0], 10);
    const year = parseInt(parts[2], 10);

    // Check the ranges of month and year
    if(year < 1000 || year > 3000 || month == 0 || month > 12)
        return false;

    var monthLength = [ 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31 ];

    // Adjust for leap years
    if(year % 400 == 0 || (year % 100 != 0 && year % 4 == 0))
        monthLength[1] = 29;

    // Check the range of the day
    return day > 0 && day <= monthLength[month - 1];
};

export const formatMomentObjectWithValue=(momentObject:moment$Moment | null,dateFormat:string)=> {
    if (momentObject && moment.isMoment(momentObject)){
        return momentObject.format(dateFormat)
    }
    return null
    //return momentObject
}

export const isValidMoment=(momentObject:moment$Moment |null)=>{
    if (momentObject && moment.isMoment(momentObject)){
        return true
    }
    return false
}

export const stringDate2MomentObject=(dateStr:string,dateFormat:string)=>{
    let momentObj=moment(dateStr,dateFormat)
    if (typeof momentObj === 'object'){
        momentObj=moment(momentObj)
    }
    return momentObj
}

export const US_DATE_FORMAT='MM/DD/YYYY'


// WEBPACK FOOTER //
// ./src/Utils/dateUtil.js